import { projectDataType } from ".";

const refractionData: projectDataType = {
  path: "refraction",
  title: "Refraction",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965332/Art-Site/Refraction/refraction-flyer-10-03-14-no-date_jv32ll.jpg",
  description:
    "A compillation of video art curated by Giselle Zatonyl, for the closing event of their residency at Culture Hub in New York City.",
  videos: ["https://vimeo.com/107929842?share=copy"],
  year: 2015,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684965332/Art-Site/Refraction/refraction-flyer-10-03-14-no-date_jv32ll.jpg",
  ],
};

export default refractionData;
